import {AuthConfig} from 'angular-oauth2-oidc';

const appTitle = 'SS&C Alerting';

export const environment = {
    title: appTitle,
    sessionRedirectName: 'redirectURL',
    common: {
        header: {
            title: appTitle,
            appNav: {
                type: 'app-nav-temp'
            },
        }
    },
    authentication: {
        company: 'SSC',
        form: {
            username: 'WSS-Master ID'
        }
    },
    oauth2: {
        // Issuer and clientId come from /config
        issuer: null,
        clientId: null,

        // URL of the SPA to redirect the user to after login
        redirectUri: window.location.origin + '/index.html',
        responseType: 'code',
        scope: 'openid profile email offline_access'
    } as AuthConfig,
    taskbar: {
        persistTo: 'sessionStorage',
        utilsNav: {
            custom: true
        }
    },
    screens: {
        client: {
            taskbarName: 'pager-taskbar'
        }
    }
};
